<template>
  <ui-card name="audience.transport_modes" rounded :error="error">
    <div class="list">
      <div class="list-header">
        <div class="list-header-item">
          <div class="header-name">
            {{ $t('audience.transport_modes.list_title.type') }}
          </div>
          <div class="header-amount">
            {{ $t('audience.transport_modes.list_title.amount') }}
          </div>
        </div>
      </div>
      <ul class="list-group">
        <li
          v-for="item in filteredModes"
          :key="item.mode"
          class="list-group-item"
        >
          <div>
            <i class="material-icons" v-if="icons[item.mode]">{{
              icons[item.mode]
            }}</i>
          </div>
          <div class="name">{{ item.name }}</div>
          <div class="bar">
            <dd :style="{ width: `${(item.amount / getMaxAmount) * 100}%` }" />
          </div>
          <div class="amount">{{ item.pct }}%</div>
        </li>
      </ul>
    </div>
  </ui-card>
</template>

<script>
import { map, filter, orderBy, first, keyBy, values, reduce } from 'lodash';
import { transportModes, transportTypes } from 'config/settings';
import { usersCf } from 'store/filters/audience';
import icons from 'utils/icons';
import { humanize } from 'utils/string';
import { mapGetters, mapState } from 'vuex';

const pastEventsDim = usersCf.dimension((d) => d._pastEvents, true);
const pastEventsGroup = pastEventsDim.group();

export default {
  name: 'TransportModes',
  data() {
    return {
      icons: icons,
    };
  },
  computed: {
    ...mapState('audience', ['users']),

    modes() {
      const { users } = this;
      const group = keyBy(pastEventsGroup.all(), 'key');
      let modes = map(transportTypes, (type) => {
        const mode = type.id;
        const id = group[mode];
        const amount = id ? id.value : 0;
        const name = this.$t(type.keypath);

        return { mode, name, amount };
      });
      const totalAmount = this.getTotalAmount(modes);

      modes = map(modes, (mode) => {
        const pct = Math.round((mode.amount / totalAmount) * 100);

        return { ...mode, pct };
      });

      return modes;
    },

    sortedModes() {
      const sortedModes = orderBy(this.modes, 'amount', 'desc');

      return sortedModes;
    },

    filteredModes() {
      return filter(this.sortedModes, (mode) => mode.amount > 0);
    },

    getMaxAmount() {
      return first(this.sortedModes).amount;
    },

    error() {
      if (this.filteredModes.length === 0) {
        return 'no_results';
      }

      return '';
    },
  },

  methods: {
    getTotalAmount(modes) {
      return reduce(modes, (acc, curr) => acc + curr.amount, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.card-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0;
}

.list-group-wrapper {
  flex: 1;
  overflow: hidden;
}

.list-group {
  margin-top: 0.5rem;
}

.header-name,
.name {
  min-width: 5.25rem;
}

.header-amount,
.amount {
  min-width: 5.75rem;
}

.bar {
  display: flex;
  align-items: center;
  flex: 1;
  padding-right: 0.875rem;

  dd {
    display: block;
    background-color: $black;
    height: 3px;
    border-radius: 1.5px;
    transition: $transition;
  }
}

.name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.amount {
  color: rgba($black, 0.64);
}

.icon-person {
  position: relative;
  top: 2px;
  font-size: 0.875rem;
}
</style>
